export default import.meta.ROLLDOWN_FILE_URL_XQdA8s8X_8azF7ZPjg1HrQ